<template>
  <body>
    <div class="main">
      <van-popup class="pop" v-model="show">
        <div class="content">
          <div class="gif_img">
            <div class="btn_pop" @click="popupShow"></div>
          </div>
        </div>
      </van-popup>
      <!--下载安装异常说明-->
      <!--		<div v-if="iosDetect()" class="course" :class="{back:showCourse}" @click="()=>{this.showCourse=!this.showCourse}"></div>-->
      <template v-if="isShow">
        <CoursePhone :viewInfo="courseInfo" />
        <transition name="slide">
          <OtherPhone v-show="otherPhoneShow" @choose="choose" />
        </transition>
          <!-- 头部 -->
        <div @click="handleDownloadBtnClick($event)" :class="['top_post downloadButton']">
          <img
            class="post"
            :src="require(`./images/1.0.1/top_logo@2x.png`)"
          /> 
        </div>
        <!-- 内容区域 -->
        <van-tabs v-model="currentIndex" class="tab_1">
          <van-tab v-for="(item, index) in tabList" :key="index" :title="item.name">
            <div class="view" ref="view">
              <div :class="['content']" @click="handleDownloadBtnClick($event)">
                <img :src="item.content" alt="" />
              </div>
              <div :class="['more' ]" @click="handleDownloadBtnClick($event)">
                <img src="./images/1.0.1/btn_more content@2x.png" alt="">
              </div>
              <!-- 安卓教程 -->
              <div class="course_choose" ref="guild" v-if="!iosDetect()">
                <MuanualAnd class="course_and" @choose="choose">
                  <template #top>
                    <div class="top_course">
                      <p>ANDROID安装说明</p>
                      <p>请选择您的手机品牌仔细阅读 安装说明</p>
                    </div>
                  </template>
                  <template>
                    <div class="row" @click="otherPhoneInfoSet(true)">
                      <img class="img" src="./images/1.0.1/other phones@2x.png" />
                    </div>
                    <div class="row" @click="choose('其它异常Tips')">
                      <img class="img" src="./images/1.0.1/download tips@2x.png" />
                    </div>
                    <div class="row" @click="choose('解除风险')">
                      <img class="img" src="./images/1.0.1/release the risk@2x.png" />
                    </div>
                    <div class="row" @click="onMessage">
                      <img class="img" src="./images/1.0.1/click@2x.png" />
                    </div>
                  </template>
                </MuanualAnd>
              </div>
              <div class="business">
                <div class="head">
                  <p>联系我们</p>
                </div>
                <div class="box">
                  <div class="contact">
                    <div class="left">客服邮箱:</div>
                    <div class="right">{{ ehelp }}</div>
                  </div>
                  <div class="contact">
                    <div class="left">商务合作:</div>
                    <div class="right">{{ ebusy }}</div>
                  </div>
                </div>
              </div>
            </div>

          </van-tab>
        </van-tabs>
        <transition name="fade">
          <IosManual v-show="showCourse && iosDetect()" />
        </transition>
        <!--底部下载栏 -->
        <div v-show="!showCourse" class="download">
          <div class="left">
            <div class="logo">
              <img :src="require(`./images/1.0.1/qqc_logo@3x.png`)" />
            </div>
            <div class="info">
              <div class="top">青青草视频</div>
              <div class="bottom"  v-if="iosDetect()">
                <img :src="require(`./images/1.0.1/icon_safari@2x.png`)" />
                <span>必须使用Safari下载苹果版APP</span>
              </div>
              <!-- android -->
              <div class="bottom" v-else>
                <img :src="require(`./images/1.0.1/icon_android@2x.png`)" />
                <span>安卓稳定版</span>
              </div>
            </div>
          </div>
          <div v-show="iosDetect()" :class="['right']"  @click="handleDownloadBtnClick($event)">下载安装</div>
          <div v-show="!iosDetect()" :class="['right']"  @click="tInstallOpen">下载安装</div>
          <transition name="silde">
            <div v-show="notSafariToastVisble" class="dialog" v-if="iosDetect()">
              <img :src="require(`./images/1.0.1/switch-browser@2x.png`)" />
            </div>
          </transition>
        </div>
      </template>
      <div class="xhy-iosAZ" v-show="isShow2">
        <div class="act-bg">
          <div class="title_1">
            <img class="title_img" src="./static/images/qqc_logo@2x.png" alt="" />
            <div class="title-right">
              <div class="right_1">青青草</div>
              <div class="right_2">八年沉淀只做精品</div>
              <div
                v-show="disp"
                class="right_3_box downloadButton3"
                @click="ioslyLoad"
              >
                <img class="right_3" :src="aimgs" alt="" />
              </div>
              <div v-show="disp2">
                <img class="dh_2" :src="aimgs2" alt="" />
              </div>
            </div>
          </div>
          <img class="xj_2_img" src="./static/images/xj_2img.png" alt="" />
          <div class="video_box">
            <video
              id="my_video"
              ref="player"
              width="100%"
              height="728"
              controls="controls"
              poster="./static/images/videocover@2x.png"
            >
              <source src="./static/images/video/qqc_az.mp4" type="video/mp4" />
            </video>
            <div
              id="app1"
              class="video_play"
              v-show="des"
              @click="togglePlay"
            ></div>
          </div>
          <img class="xz_jc" src="../images/qqc_xz_jc2x.png" alt="" />
          <div class="foot_text5">
            近期苹果封杀成人视频请大家牢记官网并下载安装
            若青青草视频信任证书无效无法进入时,重新下载信任即可
          </div>
        </div>
        <div class="footer">
          <div class="footer_left">
            <img class="footer_img" src="./static/images/qqc_logo@2x.png" alt="" />
            <div class="foot_test">
              <div class="foot_text1">青青草视频</div>
              <div class="foot_text2">八年沉淀只做精品</div>
            </div>
          </div>
          <div
            class="footer_right downloadButton3"
            v-show="disp"
            @click="ioslyLoad"
          >
            免费安装
          </div>
          <div class="footer_right" v-show="disp2">免费安装</div>
        </div>
      </div>
      <!-- RN下载页 -->
      <van-popup v-model="showRn" position="left" :style="{ height: '100%' }">
        <RnDownload @downloadRn="downloadRn" :RnKey = "ldyRnStatus.download_key"></RnDownload>
      </van-popup>
      <!-- ios下载选择弹窗 -->
      <div class="ios_down_list_view" v-show="isShowIosDownList">
        <div class="ios_down_list_content">
          <h3 @click="isShowIosDownList = false">
            <span></span>
            <p>苹果版APP下载</p>
            <img src="./images/close-1.png" alt="" />
          </h3>
          <div class="message-box">
            <img src="./images/1.0.1/use-safari@2x.png" alt="" />
          </div>
           <!-- RN版 -->
          <div class="list_item" v-show="Number(ldyRnStatus.status) == 1" @click="RnLoad">
            <img src="./images/RN@2x.png" alt="" />
          </div>
          <!-- 付费版 -->
          <!-- <div class="list_item" @click="openPay()" v-show="Number(ldyPaidStatus) == 1">
            <span class="title"></span>
            <img src="./images/ios-down-1.png" alt="" />
          </div> -->
          <!-- 永久稳定版 -->
          <div class="tem list_item" @click="tInstallOpen" v-show="Number(ldyQiyeStatus) == 1">
            <img src="./images/ios-down-2.png" alt="" />
          </div>
          <!-- 轻量版 -->
          <div class="list_item" @click="iosLoadPop" v-show="Number(ldyPwaStatus) == 1">
            <img src="./images/pwa@2x.png" alt="" />
          </div>
        </div>
      </div>

      <!-- 开通付费版弹窗 -->
      <!-- <div
        class="open_vip_pop"
        @click="isShowOpenVipPop = false"
        v-if="isShowOpenVipPop"
      >
        <div class="open_vip_view">
          <h3>开通会员 立享超级特权</h3>
          <p>开通会员 立享超级特权</p>
          <p>包含永久版下载通道</p>
          <p>无限次观影等超多特权</p>
          <i v-if="isAlreadyCreated">您已创建账号，如忘记请联系客服</i>
          <i v-else />
          <div @click="openPay()" class="button"></div>
          <b @click="onMessage()"> 联系客服 </b>
        </div>
      </div> -->

      <!-- <VipPage
        v-if="isOpenVipPage"
        @closeVip="isOpenVipPage = false"
        @checkStatus="ioslyLoad"
        @reRegister="reRegister"
      /> -->
    </div>
  </body>
</template>
<script>
import "./Main.scss";
import IosManual from "@/interface/IosManual/ViewCore";
import OtherPhone from "@/interface/OtherPhone/ViewCore";
import CoursePhone from "@/interface/CoursePhone/ViewCore";
import RnDownload from "@/interface/RnDownload/ViewCore";
import MuanualAnd from "@/interface/manualAnd/ViewCore";
import { iosDetect } from "@/libaray/js/tools";
import axios from "axios";
import Vue from "vue";
import { Popup, Cell, Toast, Tab, Tabs, Swipe, SwipeItem} from "vant";
import "vant/lib/toast/style";
import "vant/lib/index.css";
Vue.use(Popup);
Vue.use(Cell);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Swipe);
Vue.use(SwipeItem);
import { postBootstrap } from "../model/user";
// import VipPage from "./Vip.vue";
const { ehelp = "qqcyouxiang@gmail.com", ebusy = "@qqcCathleen" } =
  window.confView || {};
import config from "../config/config";

export default {
  components: {
    IosManual,
    CoursePhone,
    OtherPhone,
    // VipPage,
    RnDownload,
    MuanualAnd
  },
  data: function () {
    return {
      btn3: false,
      currentIndex: 0, //导航栏选中状态
      timer: null,
      tabList: [
        {
          name: "高清视频",
          content: require("./images/1.0.1/img_gaoqingshipin@2x.png"),
        },
        {
          name: "同城楼凤",
          content: require("./images/1.0.1/img_tongchengloufeng@2x.png"),
        },
        {
          name: "青草商城",
          content: require("./images/1.0.1/img_qingcaoshangcheng@2x.png"),
        },
        {
          name: "成人抖阴",
          content: require("./images/1.0.1/img_chengrendouyin@2x.png"),
        },
        {
          name: "午夜电台",
          content: require("./images/1.0.1/img_wuyediantai@2x.png"),
        },
        {
          name: "青草图站",
          content: require("./images/1.0.1/img_qingcaotuzhan@2x.png"),
        },
      ],
      disp: true,
      disp2: false,
      des: true,
      aimgs: require("../images/dh_1.png"),
      aimgs2: require("../images/0004.gif"),
      lastTime: 0,
      aa: require("./images/yatou.png"),
      ehelp,
      ebusy,
      slider: {
        autoplay: true,
        navButtons: false,
        autoplaySpeed: 3000,
      },
      iosDetect,
      showCourse: false,
      courseInfo: {},
      otherPhoneShow: false,
      isShow: true,
      isShow2: false,
      isShow3: true,
      isShow4: false,
      returnSy1: true,
      returnSy2: false,
      ycOne: false,
      ycTow: false,
      msg: "",
      show: false,
      ldyPwaStatus: 1, // 1开 0、null关闭
      ldyQiyeStatus: 1, // 1开 0、null关闭
      ldyPaidStatus:1, // 1开 0、null关闭
      ldyRnStatus: {}, // RN
      // ios下载选择弹窗
      isShowIosDownList: false,
      // 是否已经创建账号
      isAlreadyCreated: false,
      // 是否打开开通会员页面
      isShowOpenVipPop: false,
      // 打开vip充值界面
      isOpenVipPage: false,
      // 不是safari浏览器的toast
      notSafariToastVisble: false,
      iNumber: 0, // 下载开关打开的个数
      showRn: false,
    };
  },
  computed: {
    check() {
      if (this.question_type.length == 0) {
        return "submit";
      } else {
        return "active";
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  created() {
  // 后台配置下载版本
    axios.get(config.host + "/api/luodiye/config").then((res) => {
      console.log(res.data.code);
      try {
        this.line = res.data.data.tf_links;
        this.msg = res.data.data.notice;
        this.ldyPwaStatus = res.data.data.ldy_pwa_status;
        this.ldyQiyeStatus = res.data.data.ldy_qiye_status;
        this.ldyPaidStatus = res.data.data.ldy_paid_status;
        this.ldyRnStatus = res.data.data.ldy_rn
        let i = 0
        if(this.ldyQiyeStatus == 1) {
          i++
        }
        if(this.ldyPaidStatus == 1) {
          i++
        }
        if(this.ldyPwaStatus == 1) {
          i++
        }
        if(this.ldyRnStatus.status == 1) {
          i++
        }
        this.iNumber = i
        if (+this.ldyQiyeStatus == 1 && i == 1)
        {
          this.btn3 = true
        }
        //  this.opinstall()
      } catch (error) {
        this.$toast('数据请求失败')
      }
    });
   
  // 埋点LandingPage
    this.$sensors.track('LandingPage', {
      method: 'view',
    });
  },
  methods: {
    // 定时轮播tab
    changeTab() {
      this.timer = setInterval(() => {
      this.currentIndex++
      if(this.currentIndex > this.tabList.length ) {
        this.currentIndex = 0
      }
    }, 3000);
    },
     tInstallOpen() {
      try{
        TInstall.setHost('https://api.tickshenqu.com')
        let params = TInstall.parseUrlParams();
        params.chan_key = window.chan_key;
        params.time_xytick = '' + Math.round(new Date() / 1000);
        let that = this
        TInstall.getInstall(
          "2NPIZZ", 
          params, 
          function (res) {
            const ua = navigator.userAgent;//获取userAgent信息
            const md = new MobileDetect(ua);//实例化mobile-detect
            const os = md.os();//获取系统
            //ios系统的处理
            if (os == "iOS") {
              // 埋点
              that.$sensors.track('LandingPage', {
                method: 'download',
                pid: 'M05',
                ldy_type: 'original',
                type: 'original'
              })
              console.log('ios');
              window.location.href = window.ios_download_url;
            } else {
              //Android系统的处理
              that.$sensors.track('LandingPage', {
              method: 'download',
              pid: 'M05',
              type: 'original'
              })
              console.log('android');
              window.location.href =  window.android_download_url;
            }
        });
      } catch (e) {
        console.log(e)
      } 
    },
    handleDownloadBtnClick(e) {
      // 点击事件神策埋点
      if(e) {
        this.$sensors.quick('trackHeatMap', e.currentTarget)
      }
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // isiOS 
    if(isiOS) {
      // 埋点
      this.$sensors.track('LandingPage', {
      method: 'download',
      pid: 'M05',
    });
      if (this.iNumber > 1 ) {
      this.isShowIosDownList = true
    } else if (this.ldyQiyeStatus == 1 && this.ldyPaidStatus == 0 && this.ldyPwaStatus == 0 && this.ldyRnStatus.status == 0) {
      this.tInstallOpen()
    } else if (this.ldyPwaStatus == 1 && this.ldyQiyeStatus == 0 && this.ldyPaidStatus == 0 && this.ldyRnStatus.status == 0 ) {
      this.iosLoadPop()
    } else if (this.ldyRnStatus.status == 1 && this.ldyPwaStatus == 0 && this.ldyQiyeStatus == 0 && this.ldyPaidStatus == 0 ) {
       // 埋点
      this.$sensors.track('LandingPage', {
      method: 'download',
      pid: 'M05',
    });
      this.showRn = true
    }
    } else {
      this.tInstallOpen()
      // android埋点
      this.$sensors.track('LandingPage', {
      method: 'download',
      pid: 'M05',
      type: 'original'
    });

    }
    }, 
    // Rn 下载
    downloadRn() {
      console.log('点击RN版本下载');
      this.doCopy()
      window.open(this.ldyRnStatus.download_url,'_self')
    },
    RnLoad() {
      // 埋点
      this.$sensors.track('LandingPage', {
      method: 'download',
      pid: 'M05',
    });
      this.showRn = true;
      this.isShowIosDownList = false
    }, 
     // 获取code参数
    getUrlParam(name) {
     var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); 
     var r = window.location.search.substr(1).match(reg);
     if (r != null) return unescape(r[2]);
     return null;
 },
    // 复制粘贴
    doCopy() {
      console.log('复制');
      let code = this.getUrlParam('code')
      let _text = `${this.ldyRnStatus.download_key}&code=${code}`
      this.$copyText(_text)
        .then(() => {
          this.$toast("复制成功");
        })
        .catch((er) => {
          this.$toast.fail("复制失败");
          console.err(er);
        });
    },                                                                                                                                             
    popupShow() {
      this.show = false;
      const host = location.protocol + "//" + location.host + location.pathname;
      window.location.href = host + "webclip_download.php";
      console.log(host);
      console.log(window.location.href);
    },
    iosLoadPop() {
      window.gtag("event", "苹果轻量版");
      this.isShowIosDownList = false;
      this.show = true;
    },
    handDisp() {
      this.disp = false;
      this.disp2 = true;
      const that = this;
      setTimeout(function () {
        that.disp2 = false;
        that.disp = true;
        console.log(that.disp, "disppp");
      }, 3000);
    },
    togglePlay() {
      this.$nextTick(() => {
        let player = this.$refs.player;
        console.log(player, "player");
        player.play();
        this.des = false;
      });
    },
    onMessage() {
      //跳转客服地址
      window.location.href = "https://qqcfaq.com/new/servicemeiqia.html";
    },
    updateTFInfo(parmas) {
      this.TFInfo = { ...this.TFInfo, ...parmas };
    },
    updateCourseInfo(parmas) {
      this.courseInfo = { ...this.courseInfo, ...parmas };
    },
    open() {
      this.pop = true;
    },
    goCourse() {
      this.$refs.view.scroll.scrollToElement(this.$refs.guild, 500);
    },
    choose(params) {
      this.updateCourseInfo({ phoneType: params });
    },
    otherPhoneInfoSet(params) {
      this.otherPhoneShow = params;
    },
    applyLoad() {
      // 下载方法
      if (!iosDetect()) {
        this.goCourse();
      }
    },
    ioslyLoad() {
      this.isShowIosDownList = false;
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // isiOS isiOS
      if (isiOS) {
        // 埋点
        this.$sensors.track('LandingPage', {
        method: 'download',
        pid: 'M05',
        type: 'MDM'
        });
        window.gtag("event", "苹果稳定版");
        this.isShow2 = false
        this.ycOne = true;
        this.handDisp();
      } else {
        // 埋点
        this.$sensors.track('LandingPage', {
        method: 'download',
        pid: 'M05',
        type: 'original'
      });
      }
    },
    // ios 付费下载
    iosPaid() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // isiOS isiOS
      if (isiOS) {
        const isNewUser = localStorage.getItem("QQC_TOKEN") ? true : false;
        this.isAlreadyCreated = !isNewUser ? false : true;
        this.isShowOpenVipPop = true;
        // 获取是否为新用户
      }
    },
    // 打开充值页
    openPay() {
      var is_safari =
        navigator.vendor &&
        navigator.vendor.indexOf("Apple") > -1 &&
        navigator.userAgent &&
        navigator.userAgent.indexOf("CriOS") == -1 &&
        navigator.userAgent.indexOf("FxiOS") == -1;

      if (!is_safari) {
        window.gtag("event", "苹果至尊永久版");

        const isNewUser = localStorage.getItem("QQC_TOKEN") ? true : false;
        if (!isNewUser) {
          postBootstrap().then((res) => {
            const { token, user_id, site } = res.data;
            localStorage.setItem("QQC_TOKEN", token);
            localStorage.setItem("QQC_USER", user_id);
            localStorage.setItem("QQC_ITE", site);
            this.isOpenVipPage = true;
          });
        } else {
          this.isAlreadyCreated = true;
          this.isOpenVipPage = true;
        }
      } else {
        Toast({
          message: "请使用Safari打开此网页",
          position: "bottom",
        });
      }
    },
    // 重新登录
    reRegister() {
      this.isOpenVipPage = false;
      this.openPay();
    },
    returnSy() {
      this.isShow2 = false;
      this.isShow = true;
    },
    returnQy() {
      this.returnSy1 = true;
      this.returnSy2 = false;
      this.isShow3 = true;
      this.isShow4 = false;
      this.ycTow = false;
      this.ycOne = true;
    },
    goIsShow4() {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      this.isShow3 = false;
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      this.isShow4 = true;
      this.returnSy1 = false;
      this.returnSy2 = true;
      this.ycOne = false;
      this.ycTow = true;
    },
  },
  
  mounted() {
    const host = location.protocol+ '//' + location.host + location.pathname + 'download.json' + '?t=' + new Date().getTime()
    fetch(host)
      .then((res) => res.json())
      .then((data) => {
        const {android_download_url, ios_download_url, chan_key} = data
        window.android_download_url = android_download_url
        window.ios_download_url = ios_download_url
        window.chan_key = chan_key
    })
    var is_safari =
      navigator.vendor &&
      navigator.vendor.indexOf("Apple") > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf("CriOS") == -1 &&
      navigator.userAgent.indexOf("FxiOS") == -1;

    if (!is_safari) {
      this.notSafariToastVisble = true;
      // setTimeout(() => {
      //   this.notSafariToastVisble = false;
      // }, 2500);
    }
    this.changeTab()
    this.handDisp();
    
    

    this.updateCourseInfo({
      applogo: this.aa,
      appName: `青青草视频`,
    });
    this.updateTFInfo({
      appName: `青青草视频`,
      roller: true,
      expImg: this.aa,
      class: "qiezi",
    });
  },
};
</script>
<style lang="scss" scoped>
/deep/.van-tabs__line {
  background: #24c08e;
  border-radius: 3.5px;
  width: 20px;
  height: 3px;
  position: absolute;
  bottom: 1.3375rem;
  left: 0;
}
/deep/.van-tab--active {
  font-size: 16px;
  color: #333333;
  font-weight: 600;
}
/deep/.van-tab__text {
  font-size: 16px;
  color: #666666;
}
 /deep/.my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }
.ios_down_list_view {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 10;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  .ios_down_list_content {
    width: 100%;
    background: #fff;
    border-radius: 20px 20px 0 0;
    padding-bottom: 10px;

    h3 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      font-size: 18px;
      line-height: 18px;
      color: #333333;
      font-weight: 600;
      padding: 17px 14px 10px;
      box-sizing: border-box;

      span,
      img {
        width: 24px;
        height: 24px;
      }
    }

    .message-box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 18px;
      img {
        width: 202px;
        height: 24px;
      }
    }

    .list_item {
      width: 100%;
      box-sizing: border-box;
      width: 100%;
      padding: 8px 14px;
      position: relative;
      .title {
        position: absolute;
        right: 20px;
        top: -6px;
        width: 87px;
        height: 20px;
        background-image: url("./images/title-img.png");
        background-size: 100% 100%;
        background-position: left center;
      }
      .title2 {
        position: absolute;
        right: 20px;
        top: -5px;
        width: 87px;
        height: 20px;
        background-image: url("./images/1.0.1/zhibo@2x.png");
        background-size: cover;
        background-position: left center;
      }
      img {
        width: 100%;
      }
    }
  }
}

.open_vip_pop {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 20;

  .open_vip_view {
    margin-top: 60%;
    width: 260px;
    height: 250px;
    background-image: url("./images/open_vip_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: left top;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 40px;

    h3 {
      font-size: 20px;
      color: #402a08;
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      font-weight: 600;
      padding-bottom: 20px;
    }

    p {
      text-align: center;
      font-size: 14px;
      color: #a54400;
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      font-weight: normal;
    }

    i {
      font-size: 12px;
      color: #5c422b;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      font-style: normal;
      padding-top: 30px;
    }

    // img {
    //   width: 221px;
    //   z-index: 200000;
    // }

    div {
      width: 221px;
      height: 70px;
      background-image: url("./images/btn_open_vip.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: left top;
    }

    b {
      display: flex;
      align-items: center;
      height: 20px;
      font-size: 14px;
      color: #402a08;
      letter-spacing: 0;
      text-align: center;
      line-height: 14px;
      font-weight: 500;
      background-image: url("./images/icon_go_service.png");
      background-size: 18px 18px;
      background-repeat: no-repeat;
      background-position: right center;
      padding-right: 24px;
    }
  }
}

.pop {
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  .gif_img {
    width: 281px;
    height: 350px;
    background: url("./images/az_jc.gif") no-repeat;
    background-size: 100% 100%;
    position: relative;
    display: flex;
    justify-content: center;
    .btn_pop {
      position: absolute;
      bottom: 8px;
      width: 241px;
      height: 42px;
      background: url("./images/pop_btn.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}

.act-bg {
  width: 7.5rem;
  position: relative;
  overflow: hidden;
  width: 90%;
  margin: 0 auto;
  top: 30px;
  min-height: calc(100vh - 30px);
  font-size: 16px;
}
.title_1 {
  display: flex;
}
.title_img {
  width: 108px;
  height: 108px;
  margin-right: 14px;
}
.title-right {
  position: relative;
}
.right_1 {
  height: 28px;
  line-height: 28px;
  font-size: 20px;
  color: #000;
  font-weight: 600;
}
.right_2 {
  font-size: 14px;
  color: #8a898d;
  height: 20px;
  line-height: 20px;
  font-weight: 400;
  margin-top: 4px;
}
.right_3_box {
  height: 40px;
  width: 100px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  .right_3 {
    position: absolute;
    bottom: 0;
    height: 26px;
    width: 92px;
    display: block;
  }
}
.dh_2 {
  position: absolute;
  display: block;
  bottom: 0;
  width: 40px;
  height: 40px;
}
//.active{
//  background: url("../images/0004.gif")no-repeat ;
//  background-size: 100% 100%;
//  width: 40px;
//  height: 40px;
//}
.xj_2_img {
  width: 100%;
  display: block;
  height: 94px;
  margin-top: 23px;
}
.video_box {
  position: relative;
}
.video_play {
  background: url("../images/paly_img.png") no-repeat;
  background-size: 100% 100%;
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.xz_jc {
  display: block;
  width: 100%;
  height: 119.9375rem;
  margin-top: 30px;
}
.footer {
  position: fixed;
  width: 100%;
  height: 60px;
  background: rgba(0, 0, 0, 0.7);
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #fff;
}
.footer_left {
  height: 100%;
  display: flex;
  align-items: center;
}
.footer_img {
  width: 48px;
  height: 48px;
  margin-left: 20px;
  margin-right: 10px;
}
.foot_text1 {
  font-weight: 500;
  height: 22px;
  line-height: 22px;
  margin-bottom: 4px;
}
.foot_text2 {
  height: 16px;
  line-height: 16px;
  font-size: 11px;
  font-weight: 400;
}
.footer_right {
  width: 92px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 14px;
  background: #007afe;
  border-radius: 13px;
  margin-right: 20px;
}
.foot_text5 {
  font-size: 13px;
  color: #999999;
  text-align: center;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 80px;
  margin-top: 5px;
}

.bg-box {
  background: url("./images/bg1.png") no-repeat;
  background-size: 100% 100%;
}
.swipei-box {
  position: relative;
  .pmd {
    position: absolute;
    top: 0;
    width: 100%;
    height: 35px;
    line-height: 35px;
    align-items: center;
    background: #333333ba;
    color: #fff;
    display: flex;
    overflow: hidden;
    .pmd-ic {
      width: 2rem;
      height: 2rem;
      background: url("../portal/images/tz-1.png") no-repeat;
      background-size: 100% 100%;
      margin: 0 5px 0 10px;
    }
    .pmd-text {
      height: 35px;
      line-height: 35px;
      flex: 1;
      position: relative;
      right: 0;
    }
  }
}
.content-box {
  padding: 15px 12px 0;
  //width: 375px;
}
</style>
